import constants from 'constants/index';
import React from 'react';
import { handleSettingSkAndPkToLocalStorage } from 'utils/localStorageUtils';
import { convertDateFromApiToUserTimezone } from 'utils/utility_functions/timezone';
import { handleRedirection } from 'utils/utils';
import { useHistory } from 'react-router-dom';

function LastEditedTemplate(props) {
  const { rowData, userContext, isClientFileManager } = props;
  const history = useHistory();

  const { updated: IsoFormattedDate, updated_by_firm_user_id, sk, pk, updated_by_details } = rowData;

  const firmUserId = updated_by_firm_user_id;
  const url = firmUserId ? `/settings/team-management/${firmUserId}` : '/settings/team-management';

  const onClickUpdatedBy = (e) => {
    e.preventDefault();
    if (!isClientFileManager) {
      handleSettingSkAndPkToLocalStorage(sk, pk);
      handleRedirection(history, url, rowData);
    }
  };

  return (
    <>
      <span className="p-column-title text-break">Last Edited</span>
      <div className="d-inline-table file-manager-ellipsis-text">
        <span>
          <small
            title={convertDateFromApiToUserTimezone(
              IsoFormattedDate,
              userContext?.userDetails?.timezone,
              constants?.month_date_year_time_12_format
            )}
          >
            {convertDateFromApiToUserTimezone(
              IsoFormattedDate,
              userContext?.userDetails?.timezone,
              constants?.month_date_year_time_12_format
            )}
          </small>
        </span>

        {isClientFileManager && (
          <div
            className={`text-hint file-manager-ellipsis-text ${!isClientFileManager ? 'cursor-pointer' : ''}`}
            onClick={onClickUpdatedBy}
            title={updated_by_details || ''}
          >
            {updated_by_details || ''}
          </div>
        )}
      </div>
    </>
  );
}

export default LastEditedTemplate;
